import { GET_MANAGMENT_DATA } from "../actions/managmantDashboardData";

export default function(state = {}, action) {
  switch (action.type) {
    case GET_MANAGMENT_DATA:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/managmantDashboardData.js